import React from 'react';

// Função para formatar valores abreviados (2.6M, 1.5K, etc)
const formatarValorAbreviado = (valor, incluirRS = false) => {
  if (!valor && valor !== 0) return incluirRS ? 'R$0' : '0';
  const num = typeof valor === 'string' ? parseFloat(valor) : valor;

  const prefixo = incluirRS ? 'R$' : '';
  if (num >= 1000000) {
    return prefixo + (num / 1000000).toFixed(1) + 'M';
  } else if (num >= 1000) {
    return prefixo + (num / 1000).toFixed(1) + 'K';
  }
  return prefixo + num.toFixed(0);
};

const FormasPagamento = ({ dados = [], loading, onCrossFilter, filtroCruzadoAtivo }) => {

  // Handler para clique na linha
  const handleRowClick = (item) => {
    if (onCrossFilter) {
      onCrossFilter(item.formaPagamento);
    }
  };

  // Verificar se uma linha está selecionada
  const isRowSelected = (item) => {
    return filtroCruzadoAtivo === item.formaPagamento;
  };

  return (
    <div className="dashboard-card">
      {/* Header */}
      <h3 className="dashboard-card-header">Formas de pagamento</h3>
      <div className="dashboard-card-divider"></div>

      {/* Tabela */}
      <div className='border border-gray-300 rounded-3xl overflow-hidden flex-1 flex flex-col min-h-0'>
        {/* Header da tabela fixo */}
        <div className="border-b border-gray-200 bg-gray-50 flex-shrink-0">
          <div className="grid grid-cols-[20px_1fr_1fr_1fr]" style={{ gap: 'var(--space-fluid-xs)', padding: 'var(--space-fluid-xs) var(--space-fluid-sm)' }}>
            <span className="fluid-table-header text-center">#</span>
            <span className="fluid-table-header font-extrabold">Forma Pag.</span>
            <span className="fluid-table-header font-extrabold">Faturamento</span>
            <span className="fluid-table-header font-extrabold ">Abastecimento</span>
          </div>
        </div>

        {/* Corpo da tabela com scroll */}
        <div className="overflow-y-auto flex-1 min-h-0">
          {loading ? (
            [...Array(6)].map((_, index) => (
              <div
                key={index}
                className={`grid grid-cols-[30px_1fr_1fr_1fr] border-b border-gray-100 ${index % 2 === 1 ? 'bg-[#F1F3F7]' : 'bg-white'}`}
                style={{ gap: 'var(--space-fluid-xs)', padding: 'var(--space-fluid-sm) var(--space-fluid-xs)' }}
              >
                <div className="bg-gray-200 animate-pulse rounded" style={{ height: 'var(--icon-fluid-sm)', width: 'var(--icon-fluid-md)' }}></div>
                <div className="bg-gray-200 animate-pulse rounded" style={{ height: 'var(--icon-fluid-sm)' }}></div>
                <div className="bg-gray-200 animate-pulse rounded" style={{ height: 'var(--icon-fluid-sm)' }}></div>
                <div className="bg-gray-200 animate-pulse rounded" style={{ height: 'var(--icon-fluid-sm)' }}></div>
              </div>
            ))
          ) : dados.length > 0 ? (
            dados.map((item, index) => (
              <div
                key={index}
                onClick={() => handleRowClick(item)}
                className={`grid grid-cols-[30px_1fr_1fr_1fr] items-center border-b border-gray-200 transition-all duration-200 cursor-pointer
                  ${isRowSelected(item)
                    ? 'bg-amber-100 hover:bg-amber-200 ring-2 ring-amber-400 ring-inset'
                    : index % 2 === 1
                      ? 'bg-gray-50 hover:bg-gray-100'
                      : 'bg-white hover:bg-gray-50'
                  }`}
                style={{ gap: 'var(--space-fluid-xs)', padding: 'var(--space-fluid-xs) var(--space-fluid-sm)' }}
                title={`Clique para filtrar por ${item.formaPagamento}`}
              >
                <span className={`flex items-center px-2 ${isRowSelected(item) ? 'text-amber-700 font-semibold' : 'text-gray-600'}`} style={{ fontSize: 'var(--text-fluid-xs)' }}>
                  {item.posicao}
                </span>
                <span className={`flex items-center px-2 font-medium truncate ${isRowSelected(item) ? 'text-amber-800' : 'text-gray-800'}`} style={{ fontSize: 'var(--text-fluid-xs)' }}>
                  {item.formaPagamento}
                </span>
                <div className="flex flex-col items-start justify-center" style={{ gap: 'calc(var(--space-fluid-xs) * 0.5)' }}>
                  <div className="w-full fluid-progress-bar">
                    <div
                      className={`h-full rounded-full transition-all duration-300 ${isRowSelected(item) ? 'bg-amber-500' : 'bg-[#5F86A8]'}`}
                      style={{ width: `${Math.min(item.faturamentoPercentual || 0, 100)}%` }}
                    ></div>
                  </div>
                  <span className={`font-medium whitespace-nowrap ${isRowSelected(item) ? 'text-amber-700' : 'text-gray-700'}`} style={{ fontSize: 'var(--text-fluid-xs)' }}>
                    {formatarValorAbreviado(item.valorTotal, true)} {item.faturamentoPercentual?.toFixed(0)}%
                  </span>
                </div>
                <div className="flex flex-col items-start justify-center" style={{ gap: 'calc(var(--space-fluid-xs) * 0.5)' }}>
                  <div className="w-full fluid-progress-bar">
                    <div
                      className={`h-full rounded-full transition-all duration-300 ${isRowSelected(item) ? 'bg-amber-400' : 'bg-[#A7BDD2]'}`}
                      style={{ width: `${Math.min(item.abastecimentosPercentual || 0, 100)}%` }}
                    ></div>
                  </div>
                  <span className={`font-medium whitespace-nowrap ${isRowSelected(item) ? 'text-amber-700' : 'text-gray-700'}`} style={{ fontSize: 'var(--text-fluid-xs)' }}>
                    {formatarValorAbreviado(item.countLinhas)} {item.abastecimentosPercentual?.toFixed(0)}%
                  </span>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center text-gray-500" style={{ padding: 'var(--space-fluid-lg)', fontSize: 'var(--text-fluid-sm)' }}>
              Nenhum dado disponível
            </div>
          )}
        </div>
      </div>

      {/* Legenda */}
      <div className="flex flex-shrink-0" style={{ gap: 'var(--space-fluid-xs)', marginTop: 'var(--space-fluid-xs)' }}>
        <div className="fluid-legend">
          <span className="fluid-legend-dot bg-[#5F86A8]"></span>
          <span className="fluid-legend-text">Faturamento</span>
        </div>
        <div className="fluid-legend">
          <span className="fluid-legend-dot bg-[#A7BDD2]"></span>
          <span className="fluid-legend-text">Abastecimento</span>
        </div>
      </div>
    </div>
  );
};

export default FormasPagamento;
